import { render, staticRenderFns } from "./VisualMapPagination.vue?vue&type=template&id=188df6f0&"
import script from "./VisualMapPagination.vue?vue&type=script&lang=js&"
export * from "./VisualMapPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports